// 默认easyMock生成的文件在src/api/template下
import API from '@/api/common.js'
import * as types from './mutation-types'
import storage from 'good-storage'
import i18n from '@/i18n'
import utils from '@/utils/util'
export default {
  setUserInfo (context) {
    return new Promise(async resolve => {
      // userInfo模拟数据，真是开发环境中可以去掉，使用接口获取
      let data = {
        languageId: 'zh_CN',
        skin: 'redblack',
        breadcrumb: {
          '001': [
            // eslint-disable-next-line
            '欢迎'
          ]
        },
        code: [`${process.env.VUE_APP_CONTEXT}_001`]
      }
      // 如果不用mock数据可以打开这行
      let basicInfo = {}
      await API.basicInfo({ language: storage.get('portal_language') }).then(res => {
        basicInfo = res.data
      })
      //data['languageId'] = basicInfo.language || 'zh_CN'
      data['languageId'] = utils.browserLangMap() // basicInfo.language || 'zh_CN'
      // data['skin'] = 'redblack'
      data['skin'] = basicInfo.skin || 'redblack'
      // data['languageId'] = 'en_US'
      context.commit(types.SET_USER_INFO, data)
      context.commit(types.SET_USER_NAME, basicInfo.userName)
      context.commit(types.SET_BASICINFO, basicInfo || {})
      resolve({
        userInfo: data
      })
    })
  },
}

